import React from 'react'

import IconVipDistrictLogoSquare from '@s4l/icons/IconVipDistrictLogoSquare'
import IconVipDistrictLogoLarge from '@s4l/icons/IconVipDistrictLogoLarge'

import { BreakpointSizes } from 'src/types/device'
import { useDevice } from 'src/hooks/useDevice'

interface ILogoBrand {
  isResponsive: boolean
}

const LogoVipDistrict = ({ isResponsive = false }: ILogoBrand) => {
  const { activeBreakpoint } = useDevice()
  if (isResponsive && activeBreakpoint < BreakpointSizes.M) {
    return <IconVipDistrictLogoSquare data-testid="logo-vipdistrict-mobile" />
  }

  return <IconVipDistrictLogoLarge data-testid="logo-vipdistrict-desktop" />
}

export default LogoVipDistrict
